import { Modal } from "react-bootstrap";
import withPermission from "../../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};

const AnnuelAbsenceReportApercuModal = ({ show, metaData, onClose }: Props) => {
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          onClose();
        }}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Apercu du rapport absence annuel: {metaData?.Student?.firstname}{" "}
            {metaData?.Student?.lastname} - {metaData?.selectedYear?.label}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            {!metaData?.pdfBlobUrl ? (
              <div>Une erreur c'est produite, réessayez plus tard</div>
            ) : (
              <iframe
                src={metaData?.pdfBlobUrl}
                style={{ width: "100%", height: "100%" }}
                title="Aperçu PDF"
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-2">
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  AnnuelAbsenceReportApercuModal,
  [buildPermission(Resource.STUDENT_ABSENCE, Action.READ)],
  "masquer",
);
